import React, { useEffect, useState } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { adminPanelService } from '../../../api/services/AdminPanelService';
import type { UserStatsModel } from '../../../api/types/admin';

const COLORS = ['#0d6efd', '#198754', '#6c757d'];

const UserStatsChart: React.FC = () => {
  const [stats, setStats] = useState<UserStatsModel | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    adminPanelService
      .getUserStats()
      .then((res) => {
        if (cancelled) return;
        if (res.isSuccess && res.data) setStats(res.data);
        else setError(res.message || 'Yüklenemedi');
      })
      .catch(() => {
        if (!cancelled) setError('İstek başarısız');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return (
      <div className="d-flex align-items-center justify-content-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Yükleniyor...</span>
        </div>
      </div>
    );
  }
  if (error || !stats) {
    return (
      <div className="alert alert-warning mb-0">
        {error || 'Veri yok'}
      </div>
    );
  }

  const data = [
    { name: 'Bireysel', value: stats.personalUserCount, color: COLORS[0] },
    { name: 'Kurumsal', value: stats.corporateUserCount, color: COLORS[1] },
  ].filter((d) => d.value > 0);

  if (data.length === 0) {
    return (
      <div className="text-muted text-center py-4">
        Toplam kullanıcı: {stats.totalUserCount}
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={60}
          outerRadius={100}
          paddingAngle={2}
          dataKey="value"
          nameKey="name"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
        <Tooltip formatter={(value: number | undefined) => [value ?? 0, 'Kullanıcı']} />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
}

export default UserStatsChart;
